//ユーザーCSVアップロードページ
import React, { Fragment, useState } from 'react';
import { Typography, Button, Form, message, Input, Select, Spin } from 'antd';
import { PlusOutlined, DownloadOutlined } from '@ant-design/icons';
import Dropzone from 'react-dropzone';
import Axios from 'axios';
import config from '../../Config/key';
import Papa from 'papaparse';
import {
  decodeCsvBuffer,
  validateCsvHeaders,
  formatHeaderValidationError,
  extractAxiosErrorMessage,
} from '../../../utils/csvUploadHelper';
import {
  validateRecordDepartments,
  triggerBlobDownload,
  buildSampleRosterCsv,
  SAMPLE_CSV_FILE_NAMES,
} from '../../../utils/orgRosterHelper';
import {
  resolveCompanyRule,
  validateCompanyRows,
  formatCompanyErrorDetail,
} from '../../../utils/companyRule';
// const bcrypt = require('bcrypt');
// const saltRounds = 10;
const { Option } = Select;
const { TextArea } = Input;
const { Title, Text } = Typography;

//このアップデートはUser情報のみをアップデートする。
//Group情報及び、可変ユーザデータのアプデーとは行いません。

// CSV に必須の列（email のみ）
const REQUIRED_COLUMNS = ['email'];

function CSVUserUpdatePage(props) {
  const [fileData, setFileData] = useState();
  const [fileJSON, setFileJSON] = useState();
  const [groups, setGroups] = useState([]); //グループ名とグループコード

  // let department = [];
  // let position = [];
  // let empType = [];
  // let levelCode = [];
  // let goOut = [];
  // const [projectDescriptionValue, setProjectDescriptionValue] = useState('');
  const [groupCode, setGroupCode] = useState('');
  const [submitButtonDisable, setSubmitButtonDisable] = useState(true);
  // 処理中フラグ（大量件数で待機が長い間、二重送信防止 + 全画面スピナー）
  const [processing, setProcessing] = useState(false);

  const onDrop = async (files) => {
    const file = files[0];
    const reader = new FileReader();
    reader.onabort = () => console.log('file reading was aborted');
    reader.onerror = () => console.log('file reading failed');
    reader.onload = (e) => {
      //ファイルの読み込みが終わったら発火
      // decodeCsvBuffer で文字コード自動判定 + 先頭 BOM 除去まで一括処理
      const unicodeString = decodeCsvBuffer(e.target.result);
      Papa.parse(unicodeString, {
        header: true,
        dynamicTyping: false,
        skipEmptyLines: true,
        complete: async (results) => {
          // 必須列の存在検証（BOM は decodeCsvBuffer で除去済み、その他不可視文字を捕捉）
          const headers = (results.meta && results.meta.fields) || [];
          const v = validateCsvHeaders(headers, REQUIRED_COLUMNS);
          if (!v.ok) {
            message.error({
              content: formatHeaderValidationError(v),
              key: 'csvupload',
              duration: 10,
            });
            setFileJSON(undefined);
            setFileData(
              'エラー：CSVヘッダーを確認の上、再アップロードしてください。'
            );
            return;
          }
          setFileData(unicodeString);
          setFileJSON(results.data);
          //const courseInfo = courseMerge(results.data);
          // setProjectKeyValue(`${courseInfo.course_id}_${ymdhms()}`);
          // console.log({ courseInfo });
        },
      });
    };
    reader.readAsArrayBuffer(file); //ファイルを読み込む
    const group = await Axios.get('/api/group/');
    setGroups(group.data.groups);
    // console.log(group.data.groups);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    let userData = []; //最終分類用
    setProcessing(true);
    try {
      message.loading({
        content: 'CSVアップロード中...（件数が多い場合は時間がかかります）',
        key: 'csvupload',
        duration: 0,
      });

      // CSVが正しく読み込まれているかを検証（email列なしで弾かれた場合は fileJSON が undefined）
      if (!fileJSON || !Array.isArray(fileJSON) || fileJSON.length === 0) {
        message.error({
          content:
            '有効なCSVファイルがアップロードされていません。CSVを再確認してください。',
          key: 'csvupload',
          duration: 3,
        });
        throw new Error('CSVデータがありません。');
      }

      if (!groupCode) {
        message.error({
          content: '企業コードを入力してください。',
          key: 'csvupload',
          duration: 2,
        });
        throw new Error('企業コードがありません。');
      }
      const res = await Axios.get(`/api/group/${groupCode}`);
      if (res.data.success) {
        // console.log(res.data.group);
        // if (res.data.group.department) {
        //   department = res.data.group.department;
        // }
        // if (res.data.group.position) {
        //   position = res.data.group.position;
        // }
        // if (res.data.group.emp_type) {
        //   empType = res.data.group.emp_type;
        // }
        // if (res.data.group.level_code) {
        //   levelCode = res.data.group.level_code;
        // }
        // if (res.data.group.go_out) {
        //   goOut = res.data.group.go_out;
        // }
      } else {
        message.error({
          content: '企業コードを確認してください。',
          key: 'csvupload',
          duration: 2,
        });
        throw new Error('企業情報の取得ができませんでした。');
      }
      // console.log({ fileJSON });

      // 系列会社ありグループのみ: company 列がある行の会社名を検証し、誤りがあれば中断する
      // （本画面の所属名チェックと同じく「N 行目: 理由」で知らせる。権限を問わず空欄もエラー）
      // 系列会社名は GET /api/group/:code/company-list から取得（失敗時はグループの系列会社マスタ。
      // 系列会社なしグループは API を呼ばず無効＝従来どおり）
      const companyRule = await resolveCompanyRule(groupCode, res.data.group);
      if (companyRule.enabled) {
        const companyErrors = validateCompanyRows(companyRule, fileJSON, {
          isTarget: (r) => !!r && Object.prototype.hasOwnProperty.call(r, 'company'),
        });
        if (companyErrors.length > 0) {
          const head = companyErrors
            .slice(0, 5)
            .map((r) => `${r.row} 行目: ${r.error}`)
            .join(' / ');
          const rest =
            companyErrors.length > 5 ? `（ほか ${companyErrors.length - 5} 件）` : '';
          throw new Error(`${head}${rest}`);
        }
      }

      await fileJSON.map((record, idx) => {
        // 所属名の入力規則（「／」禁止・制御文字禁止・50 文字以内）に反する行があれば中断
        const deptNameError = validateRecordDepartments(record);
        if (deptNameError) {
          throw new Error(`${idx + 1} 行目: ${deptNameError}`);
        }
        // let dpString = '';
        // if (record.department) {
        //   dpString = record.department;
        //   if (!department.find((item) => item === dpString)) {
        //     // setDepartment([...department, record.department]);
        //     department.push(dpString);
        //     // console.log(`dpString:${dpString}`);
        //   }
        //   if (record.department2) {
        //     dpString = record.department + '／' + record.department2;
        //     if (!department.find((item) => item === dpString)) {
        //       // setDepartment([...department, record.department]);
        //       department.push(dpString);
        //       // console.log(`dpString:${dpString}`);
        //     }
        //     if (record.department3) {
        //       dpString =
        //         record.department +
        //         '／' +
        //         record.department2 +
        //         '／' +
        //         record.department3;
        //       if (!department.find((item) => item === dpString)) {
        //         // setDepartment([...department, record.department]);
        //         department.push(dpString);
        //         // console.log(`dpString:${dpString}`);
        //       }
        //       if (record.department4) {
        //         dpString =
        //           record.department +
        //           '／' +
        //           record.department2 +
        //           '／' +
        //           record.department3 +
        //           '／' +
        //           record.department4;
        //         if (!department.find((item) => item === dpString)) {
        //           // setDepartment([...department, record.department]);
        //           department.push(dpString);
        //           // console.log(`dpString:${dpString}`);
        //         }
        //         if (record.department5) {
        //           dpString =
        //             record.department +
        //             '／' +
        //             record.department2 +
        //             '／' +
        //             record.department3 +
        //             '／' +
        //             record.department4 +
        //             '／' +
        //             record.department5;
        //           if (!department.find((item) => item === dpString)) {
        //             // setDepartment([...department, record.department]);
        //             department.push(dpString);
        //             // console.log(`dpString:${dpString}`);
        //           }
        //         }
        //       }
        //     }
        //   }
        // }
        // if (record.position) {
        //   dpString = record.position;
        //   if (!position.find((item) => item === dpString)) {
        //     position.push(dpString);
        //   }
        // }
        // if (record.emp_type) {
        //   dpString = record.emp_type;
        //   if (!empType.find((item) => item === dpString)) {
        //     empType.push(dpString);
        //   }
        // }
        // if (record.level_code) {
        //   dpString = record.level_code;
        //   if (!levelCode.find((item) => item === dpString)) {
        //     levelCode.push(dpString);
        //   }
        // }
        // if (record.go_out) {
        //   dpString = record.go_out;
        //   if (!goOut.find((item) => item === dpString)) {
        //     goOut.push(dpString);
        //   }
        // }

        // ★本画面は「ユーザー本体の誤りを部分修正する」専用のため、所属の単位補完
        //   （orgRosterHelper.completeDepartmentChain）を意図的に適用しない。
        //   CSV に存在する列だけを更新し、存在しない階層は据え置く（中間階層だけの修正が可能）。
        //   特定階層を消したい場合は、その列を残して空欄にする（'' で上書き）。
        let element = {};
        element.email = record.email;
        if (record['lastname'] !== undefined)
          element.lastname = record.lastname;
        if (record['lastname_yomi'] !== undefined)
          element.lastname_yomi = record.lastname_yomi;
        if (record['name'] !== undefined) element.name = record.name;
        if (record['name_yomi'] !== undefined)
          element.name_yomi = record.name_yomi;
        if (record['role'] !== undefined) element.role = record.role;
        if (record['department'] !== undefined)
          element.department = record.department;
        if (record['company'] !== undefined) element.company = record.company;
        if (record['department'] !== undefined)
          element.department = record.department;
        if (record['department2'] !== undefined)
          element.department2 = record.department2;
        if (record['department3'] !== undefined)
          element.department3 = record.department3;
        if (record['department4'] !== undefined)
          element.department4 = record.department4;
        if (record['department5'] !== undefined)
          element.department5 = record.department5;
        if (record['position'] !== undefined)
          element.position = record.position;
        if (record['manager'] !== undefined) element.manager = record.manager;
        if (record['level_code'] !== undefined)
          element.level_code = record.level_code;
        if (record['go_out'] !== undefined) element.go_out = record.go_out;
        if (record['inactive'] !== undefined) {
          element.inactive = record.inactive;
        } else {
          element.inactive = false;
        }
        if (record['age'] !== undefined) element.age = record.age;
        if (record['sex'] !== undefined) element.sex = record.sex;
        if (record['work_term'] !== undefined)
          element.work_term = record.work_term;
        if (record['change_password'] !== undefined)
          element.change_password = record.change_password;
        if (record['emp_no'] !== undefined) element.emp_no = record.emp_no;
        if (record['emp_type'] !== undefined)
          element.emp_type = record.emp_type;
        if (record['birthday'] !== undefined)
          element.birthday = record.birthday;
        if (record['join_company'] !== undefined)
          element.join_company = record.join_company;
        if (record['job_type'] !== undefined)
          element.job_type = record.job_type;
        if (record['age_range'] !== undefined)
          element.age_range = record.age_range;
        if (record['work_location'] !== undefined)
          element.work_location = record.work_location;
        if (record['work_time_rule'] !== undefined)
          element.work_time_rule = record.work_time_rule;
        if (record['work_time'] !== undefined)
          element.work_time = record.work_time;
        if (record['join_type'] !== undefined)
          element.join_type = record.join_type;
        // ★パスワード関連の優先順位はサーバー（PATCH /api/users/csvuserupdate）で決定する:
        //   password に値がある行 → init_pass=その平文・change_password=false を自動設定し、
        //   CSV の init_pass / change_password 列の値は無視。password が空の行のみ両列をそのまま反映。
        if (record['init_pass'] !== undefined)
          element.init_pass = record.init_pass;
        if (record['password'] !== undefined)
          element.password = record.password;
        if (record['e3_department'] !== undefined) {
          element.e3_department = [];
          element.e3_department.push(record.e3_department);
        }
        // if (record.lastname) element.lastname = record.lastname;
        // if (record.name) element.name = record.name;
        // if (record.department) element.department = record.department;
        // if (record.company) element.company = record.company;
        // if (record.department) element.department = record.department;
        // if (record.department2) element.department2 = record.department2;
        // if (record.department3) element.department3 = record.department3;
        // if (record.department4) element.department4 = record.department4;
        // if (record.department5) element.department5 = record.department5;
        // if (record.position) element.position = record.position;
        // if (record.manager) element.manager = record.manager;
        // if (record.level_code) element.level_code = record.level_code;
        // if (record.go_out) element.go_out = record.go_out;
        // if (record.age) element.age = record.age;
        // if (record.sex) element.sex = record.sex;
        // if (record.work_term) element.work_term = record.work_term;
        // if (record.change_password)
        //   element.change_password = record.change_password;
        // if (record.emp_no) element.emp_no = record.emp_no;
        // if (record.emp_type) element.emp_type = record.emp_type;
        // if (record.birthday) element.birthday = record.birthday;
        // if (record.join_company) element.join_company = record.join_company;
        // if (record.age_range) element.age_range = record.age_range;
        // if (record.work_location) element.work_location = record.work_location;
        // if (record.work_time_rule)
        //   element.work_time_rule = record.work_time_rule;
        // if (record.work_time) element.work_time = record.work_time;
        // if (record.join_type) element.join_type = record.join_type;
        // if (record.init_pass) element.init_pass = record.init_pass;
        userData.push(element);
      });

      // const groupData = { department, position, empType, levelCode, goOut };
      // const [res2, res3] = await Promise.all([
      //   Axios.patch(`/api/group/${groupCode}`, groupData),
      //   Axios.patch('/api/users/csvuserupdate', userData),
      // ]);
      // console.log({ userData });
      const res2 = await Axios.patch('/api/users/csvuserupdate', userData);

      // Axios.patch(`/api/group/${groupCode}`, department),

      // console.log({ res3 });
      if (res2.data.success) {
        setFileData('CSVアップデートが完了しました。');
        message.success({
          content: 'アップデート完了！',
          key: 'csvupload',
          duration: 2,
        });
        setTimeout(() => {
          props.history.push('/');
        }, 1000);
      } else {
        message.error({
          content: 'CSVアップデートに失敗しました。',
          key: 'csvupload',
          duration: 2,
        });
        throw new Error('CSVアップデートに失敗しました。');
      }
    } catch (error) {
      console.log({ error });
      // バックエンドの具体的なエラー本文を抽出して表示（運用担当が pm2 logs 参照不要）
      // サーバーが会社名の検証エラー（company_errors）を返した場合は先頭 5 件を併記する
      const companyDetail = formatCompanyErrorDetail(error);
      message.error({
        content:
          extractAxiosErrorMessage(error, 'CSVアップデートに失敗しました。') +
          companyDetail,
        key: 'csvupload',
        duration: companyDetail ? 10 : 5,
      });
    } finally {
      setProcessing(false);
    }
  };

  const onChangeGroup = (value) => {
    if (value) {
      setGroupCode(value);
      setSubmitButtonDisable(false);
    }
    // console.log(e);
  };

  // サンプル CSV（この画面はフルパス非対応のため個別列の例）
  const downloadSampleCsv = () => {
    triggerBlobDownload(
      buildSampleRosterCsv('updateOnly'),
      SAMPLE_CSV_FILE_NAMES.updateOnly,
      'text/csv;charset=utf-8'
    );
  };

  return (
    <Fragment>
      <Spin
        spinning={processing}
        fullscreen
        tip="処理中です。完了までこのままお待ちください…"
      />
      <div style={{ maxWidth: '700px', margin: '2rem auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Title level={2}>受講者 CSV Update (NO GSD, NO VUD)</Title>
          <Title level={4}>
            GSD : Group Summery Data, VUD : Variable User Data
          </Title>
        </div>
        <Form onSubmit={onSubmit}>
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❶</Title>
          {/* サンプル CSV（ヘッダー＝英字フィールド名・2026-10-07） */}
          <div style={{ marginBottom: 'var(--space-3)' }}>
            <Button icon={<DownloadOutlined />} onClick={downloadSampleCsv}>
              サンプル CSV ダウンロード
            </Button>
            <Text type="secondary" style={{ display: 'block', marginTop: 'var(--space-1)' }}>
              ヘッダーは英字のフィールド名です。この画面の所属は department〜department5 の個別列で指定します。
            </Text>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {/* Drop zone */}
            <Dropzone onDrop={onDrop} multiple={false} maxSize={1000000000}>
              {({ getRootProps, getInputProps }) => (
                <div
                  style={{
                    width: '300px',
                    height: '240px',
                    border: '1px solid lightgray',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  {...getRootProps()}
                >
                  <input {...getInputProps()} />
                  <PlusOutlined style={{ fontSize: '3rem' }} />
                </div>
              )}
            </Dropzone>
            <div
              style={{
                width: '300px',
                height: '240px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Text mark>
                CSVファイルをDrag &
                Dropするか、+を押してファイルを選択してください。
              </Text>
            </div>
          </div>
          <br />
          <div>
            <Title style={{ color: 'var(--brand-primary)' }}>❷</Title>
            {/* <Text strong>企業コードを入力してください（必須）</Text>
            <Input
              placeholder="一意になる企業コードを入力してください。"
              allowClear
              onChange={onChangeGroupCode}
              value={groupCode}
            /> */}
            <Text strong style={{ display: 'block', marginBottom: 'var(--space-4)' }}>企業を選択してください。（必須）</Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Select
                showSearch
                style={{ marginLeft: 0, marginRight: 10, width: 300 }}
                placeholder="企業選択"
                optionFilterProp="children"
                onChange={onChangeGroup}
                value={groupCode}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {groups.map((element) => {
                  // console.log({ element });
                  return (
                    <Option value={element.group_code} key={element._id}>
                      {element.group_name}
                    </Option>
                  );
                })}
              </Select>
            </div>
            <br />
          </div>
          <br />
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❸</Title>
          <Button
            type="primary"
            size="large"
            onClick={onSubmit}
            disabled={submitButtonDisable || processing}
            loading={processing}
          >
            アップデート
          </Button>
        </Form>
        <TextArea rows={20} value={fileData} />
      </div>
    </Fragment>
  );
}

export default CSVUserUpdatePage;
